import { ITimelineConfig } from './typings';

const config: ITimelineConfig = {
  displayMode: undefined,
};

export default config;
